import React from "react";
import { Box, Grid, Typography, Button } from "@mui/material";
import imgUrl from "../assets/images/imgUrl";
import { useNavigate } from "react-router";

export default function Pledge() {
    const navigate = useNavigate();
  return (
    <>
      {/* Home section */}
      <Box
        className="pledgeSectionBg commonBannerBg"
        sx={{
          backgroundSize: "cover",
          backgroundPosition: "center",
          // position: "relative",
          color: "white",
          px: 2,
        }}
      >
        {/* Mini Header (Top-Left) */}
        <Box
          sx={{
            position: "absolute",
            top: 80,
            left: 0,
            display: "flex",
            alignItems: "center",
          }}
        >
         <Box
            component="img"
            src={imgUrl.doveImg}
            alt="Peace Dove Logo"
            sx={{ maxWidth: 200, height: "auto", mr: 1 }}
          />
        </Box>
      </Box>

      {/* Pledge section */}
      {/* <Box className="pledge-section pledge-description">
        
            <Typography variant="h6" className="pledge-heading">
              The I Am Peacekeeper Commitment
              <br />
              one of the planet’s most inspiring global
              <br />
              commitment to peace.
            </Typography>
          

      </Box> */}
      <Box className="pledge-section" pt={0}>
        <Grid container direction="column" alignItems="center" spacing={3}>
         
          <Grid size xs={12} mt={5}>
             <img src={imgUrl.peaceIcon} className='w-100 peaceImg'></img>
            <Typography variant="h5" className="pledge-title">
              Pledge
            </Typography>
          </Grid>

          <Grid size xs={12} md={12} lg={12}>
          <div className="pledgeQuotes">
            <Typography variant="body1" className="pledge-text">
              I Am Peacekeeper. I commit <br></br> myself to Global Justice, <br></br> Love &amp;
              Peace and will <br></br> spread it. Peace
            </Typography>
          </div>
            
          </Grid>

          <Grid size xs={12} mb={5} mt={2}>
            <Button variant="contained" className="blueButton"  onClick={() => navigate("/login")}>
              Download I Am Peacekeeper Certificate
            </Button>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
